module.exports = __webpack_public_path__ + "static/img/wall-conveyor-perpendicular_64.d64ed33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wall-conveyor-perpendicular_64.png
// module id = nfwQ
// module chunks = 0